import React from "react";
import {useTranslation} from "react-i18next";

const PackageCreditPersonsPillow = (props: {peopleCount: number}) => {
    const {t} = useTranslation();

    return <div className={"font-semibold text-xs text-black p-1"}>{t("Applies to all {{count }} persons", {count: props.peopleCount})}</div>;
};

export default PackageCreditPersonsPillow;
